import {
  BIKE_SHARE_VERTEX_TYPE,
  DESTINATION_LOCATION_TYPE,
  ORIGIN_LOCATION_TYPE,
  SCOOTER_CATEGORY_ID,
} from '#/shared/constants';

/**
 * The trip planner returns some micromobility legs with a `name` property
 * that's an id comprised of random characters.  This utility catches those
 * cases and replaces them with internationalized, human-readable labels
 *
 * @param {Object} leg Leg from OpenTripPlanner itinerary
 * @param {Object} otpUiConfig otp-ui configuration object
 * @param intl Object containing i18n methods from `react-intl`
 * @returns {Object} Cloned itinerary leg with updated place names
 */
const updateMicroMobilityNames = (leg, otpUiConfig, intl) => {
  const scooterNetworkNameMap = otpUiConfig.modes.categories
    .find(el => el.id === SCOOTER_CATEGORY_ID)
    .options.reduce(
      (obj, scooter) => ({
        ...obj,
        [scooter.company]: scooter.label,
      }),
      {}
    );

  const legUpdates = {};

  [ORIGIN_LOCATION_TYPE, DESTINATION_LOCATION_TYPE].forEach(placeType => {
    const place = leg[placeType];
    const scooterNetworkName = scooterNetworkNameMap[place.networks?.[0]];
    let nextPlaceName = null;

    // OTP returns a bike id for legs that are on a floating BIKETOWN
    // bike, ideally the engine would return a human readable name
    const floatingBikeIdRegex = /^[0-9-]*$/;

    if (scooterNetworkName) {
      nextPlaceName = intl.formatMessage(
        { id: 'planner.floating-scooter-name' },
        { company: scooterNetworkName }
      );
    } else if (
      place.vertexType === BIKE_SHARE_VERTEX_TYPE &&
      floatingBikeIdRegex.test(place.name)
    ) {
      nextPlaceName = intl.formatMessage({
        id: 'planner.biketown-floating-bike-name',
      });
    }

    legUpdates[placeType] = {
      ...place,
      name: nextPlaceName || place.name,
    };
  });

  return {
    ...leg,
    ...legUpdates,
  };
};

export default updateMicroMobilityNames;
